import React from "react";

const Chapter2 = () => {
  return (
    <>
      <h2>Why should I care?</h2>
      <p>
        Although essential in small quantities, trace elements can become toxic
        or bioaccumulate over time. High levels of metals and trace elements
        cannot be correctly processed by humans or wildlife.{" "}
      </p>
      <p>
        If an element occurs at rates faster than wildlife can process it
        naturally, accumulation of that element occurs over time, which is
        called bioaccumulation. Even if an element is harmless to one species,
        bioaccumulation in the food chain can cause problems in other species.
        For example, Selenium can cause reproductive issues in fish when
        bioaccumulation occurs lower in the food chain.{" "}
      </p>
      <p>
        If found at high levels in drinking water, other elements, such as lead
        and arsenic, can directly cause cancer, reproductive problems, and
        kidney problems. Radioactive elements, like uranium and radon, can be
        carcinogenic and cause organ failures.
      </p>
      <p>
        While trace elements are necessary for human life, they can also be a
        direct threat to human health if occurring at high rates in drinking
        water. Similarly, aquatic wildlife can suffer if metals and other trace
        elements are present at inappropriate levels in waterways.
      </p>
    </>
  );
};

export default Chapter2;
